import { Component, effect, input, model, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-expandable-card",
  imports: [MatButtonModule, MatIconModule],
  templateUrl: "./expandable-card.component.html",
  styleUrl: "./expandable-card.component.scss",
})
export class ExpandableCardComponent {
  readonly title = input.required<string>();
  readonly initiallyExpanded = input<boolean>(true);
  readonly whiteBackground = input<boolean>(false);

  readonly expanded = model<boolean>();

  readonly internalExpanded = signal(this.initiallyExpanded());

  constructor() {
    effect(() => {
      if (this.expanded() !== undefined) {
        this.internalExpanded.set(this.expanded()!);
      }
    });
  }

  isExpanded(): boolean {
    return this.expanded() !== undefined
      ? this.expanded()!
      : this.internalExpanded();
  }

  toggleExpanded(): void {
    const newValue = !this.isExpanded();

    if (this.expanded() !== undefined) {
      this.expanded.set(newValue);
    } else {
      this.internalExpanded.set(newValue);
    }
  }
}
